import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { Image, View } from 'react-native';

import logoLeths from '../assets/images/logo_purple.png';
import rotatePhoneImage from '../assets/images/rotate_phone.gif';
import { AppText } from '../components/form';
import screenOptions from '../config/screenOptions';
import { getOrientarion, pixelDimensions } from '../config/utils';
import { WelcomeOne, WelcomeThree, WelcomeTwo } from '../screens/welcome';

const Welcome = createStackNavigator();
const WelcomeNavigator = () => {
  const orientation = getOrientarion();
  return (
    orientation === 'PORTRAIT'
      ? (
        <Welcome.Navigator screenOptions={screenOptions}>
          <Welcome.Screen name="Welcome One" component={WelcomeOne} />
          <Welcome.Screen name="Welcome Two" component={WelcomeTwo} />
          <Welcome.Screen name="Welcome Three" component={WelcomeThree} />
        </Welcome.Navigator>
      )
      : (
        <View style={{
          flex: 1, backgroundColor: 'white', justifyContent: 'center', alignItems: 'center',
        }}
        >
          <Image source={logoLeths} style={{ height: pixelDimensions(12), width: pixelDimensions(12) * (75 / 22) }} />
          <AppText size="bold" style={{ fontSize: pixelDimensions(10), textAlign: 'center' }}>Bem-Vindo</AppText>
          <AppText style={{ fontSize: pixelDimensions(3), textAlign: 'center' }}>Acesse pelo seu celular para visualizar nosso app</AppText>
          <Image source={rotatePhoneImage} style={{ width: pixelDimensions(50), height: pixelDimensions(50) }} />
        </View>
      )
  );
};

/* const WelcomeNavigator = () => {
  const [ orientation, changeOrientation ] = useState();
  return (
    orientation === 'PORTRAIT' ?
    <Welcome.Navigator screenOptions={screenOptions} >
      <Welcome.Screen name="Welcome One" component={WelcomeOne} />
      <Welcome.Screen name="Welcome Two" component={WelcomeTwo} />
      <Welcome.Screen name="Welcome Three" component={WelcomeThree} />
    </Welcome.Navigator>
    :
    <View onLayout={()=>changeOrientation( getOrientarion() )} style={{ flex: 1, backgroundColor: 'white', justifyContent: 'center', alignItems: 'center' }}>
      <AppText size='bold' style={{ fontSize: pixelDimensions(10), textAlign: 'center' }}>Bem-Vindo</AppText>
      <AppText style={{ fontSize: pixelDimensions(3), textAlign: 'center' }}>{`Esse app só pode ser usado em smartphones ou dispositivos com\no alto da tela maior do que o largo (Orientação: Retrato/Portrait).`}</AppText>
      <Image source={rotatePhoneImage} style={{ width: pixelDimensions(50), height: pixelDimensions(50) }} />
    </View>
)}; */

export default WelcomeNavigator;
